import { handleActions } from "redux-actions";
import { setConvertersManagerOpen } from "../actions/actions";

export default handleActions(
  {
    [setConvertersManagerOpen]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
